import React, { useEffect, useRef } from "react";
import Hero from "../Components/Hero";
import Clients from "../Components/Clients";
import InfoBlog from "../Components/InfoBlog";
const Home = () => {
	const vidRef1 = useRef();
	const vidRef2 = useRef();
	const vidRef3 = useRef();

	useEffect(() => {
		vidRef1.current.play();
		vidRef2.current.play();
		vidRef3.current.play();
	}, []);
	return (
		<div>
			<Hero />
			<Clients />
			<section className="py-12 bg-white sm:py-16 lg:py-20">
				<InfoBlog vidRef={vidRef1} src="/static/images/identifyText.mp4" flip={false} title="Capture only what you want" subtitle="Keep your data clean and crisp – upload unstructured invoices from multiple customers but only extract fields you need. You can also add new fields if required." />
				<InfoBlog vidRef={vidRef2} src="/static/images/orderingDocuments.mp4" flip={true} title="AI that learns with every new document" subtitle="As your business grows, the more transactions and the more data you will deal with. The model keeps learning and will be able to understand and capture data with higher accuracy each time new documents are processed." />
				<InfoBlog vidRef={vidRef3} src="/static/images/transferringData.mp4" flip={false} title="Seamlessly upload documents and export data" subtitle="Customers send you documents only via email? Nanonets supports platforms you can directly import from or export to your existing workflow without disrupting your system." />
			</section>
		</div>
	);
};

export default Home;
